export type FieldType =
  | 'standard'
  | 'mime'
  | 'feature'
  | 'orderdetail'
  | 'price'
  | 'logistics'
  | 'reference'
  | 'udx'
  | 'seo'
  | 'legal'
  | 'misc'
  | 'supplier'
  | 'esales'
  | 'wawi'
  | 'fixed'
  | 'category'
  | 'packing'
  | 'shopware6'
  | 'wawi'
  | 'kiprompt'
  | 'sellsite_neu'
  | 'sellThroughFigures'
  | 'texts';

export class NextPimField {
  constructor(
    public elementKey?: string,
    public systemKey?: string,
    public field?: string,
    public useSequence: boolean = false,
    public currentFilter: boolean = false,
    public fieldType: FieldType = "standard",
    public order?: number,
  ) {
  }
}

export function HasSystemKey(nextPimField: NextPimField): boolean {
  if (!nextPimField.systemKey)
    return false;
  if (nextPimField.systemKey == "-1")
    return false;
  if (nextPimField.systemKey == "0")
    return false;
  return true;
}

export function HasElementKey(nextPimField: NextPimField): boolean {
  if (!nextPimField.elementKey)
    return false;
  if (nextPimField.elementKey == "-1")
    return false;
  if (nextPimField.elementKey == "0")
    return false;
  return true;
}
